import { SectionHeading } from "@/components/shared/SectionHeading";
import { Reveal, RevealStagger, RevealItem } from "@/components/shared/Reveal";
import { ArrowRight } from "lucide-react";
import { openPreRegister } from "@/lib/preRegisterModal";

const CAPABILITIES = [
  "Add a truck", "Verify vehicle information", "Maintain insurance information", "Post a driver request",
  "Search qualified drivers", "Set compensation", "Secure required funds", "Track the incoming driver",
  "Complete a documented handoff", "Monitor the assignment", "Review delivery records",
];

export const OwnerOperators = () => {
  return (
    <section id="owner-operators" data-testid="owner-operators-section" className="py-24 md:py-32 bg-rr-surface">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-[1fr_0.8fr] gap-16 items-center">
        <div>
          <SectionHeading
            eyebrow="For Owner Operators"
            title="Your Truck. Your Load. Get the Driver Help You Need."
            description="An owner operator may have a perfectly functional truck and an active load but become unable to continue driving. RelayRigs provides a mechanism for requesting qualified driver assistance without recreating the entire shipment."
            testId="owner-operators"
          />
          <Reveal delay={0.3}>
            <button onClick={() => openPreRegister("need_driver")} data-testid="find-a-driver-cta" className="mt-9 inline-flex items-center gap-2 bg-rr-navy text-white font-bold px-7 py-4 rounded-full hover:bg-rr-orange transition-all hover:-translate-y-1">
              Find a Driver <ArrowRight size={18} />
            </button>
            <p data-testid="return-trip-policy-note" className="mt-4 text-xs text-rr-muted max-w-sm">
              Requesting relief? Your compensation offer must include funding your relief driver's way home — RelayRigs does not book or provide that travel.
            </p>
          </Reveal>
        </div>

        <RevealStagger className="grid grid-cols-1 gap-2.5">
          {CAPABILITIES.map((c, i) => (
            <RevealItem key={c}>
              <div data-testid={`owner-operator-capability-${i}`} className="flex items-center gap-3 bg-white border border-rr-line rounded-xl px-5 py-3.5 hover:border-rr-orange/50 transition-colors">
                <span className="w-6 h-6 rounded-full bg-rr-navy text-white text-[10px] font-bold flex items-center justify-center shrink-0">{i + 1}</span>
                <span className="text-sm font-semibold text-rr-navy">{c}</span>
              </div>
            </RevealItem>
          ))}
        </RevealStagger>
      </div>
    </section>
  );
};
